import emailjs from 'emailjs-com'
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './Contact.css'

export default function Contact () {
    const { pathname } = useLocation();
    useEffect(() => {
    window.scrollTo(0, 0)
    }, [pathname]);

    const[mail, setMail] = useState('');
    const[name, setName] = useState('');
    const[surname, setSurname] = useState('');
    const[message, setMessage] = useState('');

    function SendEmail(e) {
        e.preventDefault() 
        
        emailjs.sendForm('gmail', 'template_8247nal', 
          e.target, 'Kb8c3PwGoXLYnP4tl')
          .then((result) => {
            alert('Your message has been sent. We will go back to you shortly.')
            setMail('');
            setMessage('');
            setName('');
            setSurname('');
                console.log(result.text);
            }, 
             (error) => {
                alert('Something went wrong! Please, try again.')
                console.log(error.text);
             });
        }

    return (
    <section className='contactMainSection'>
        <h1 className='contact_title'>CONTACT</h1>
        <div className="contactForm">
            <form onSubmit={SendEmail}>
                <div className='labelAndInput'>
                    <div>
                        <label htmlFor="Name">Name<span className='redStar'>*</span> </label>
                        <br/>
                        <input className='contactInputs' name="surname" type="text" required 
                        value={name} onChange={(e)=>setName(e.target.value)}/>
                    </div>
                    <div>
                        <label htmlFor="Name">Surname<span className='redStar'>*</span></label>
                        <br/>
                        <input  className='contactInputs' name="surname" type="text" required 
                        value={surname} onChange={(e)=>setSurname(e.target.value)}/>
                    </div>
                </div>
                <br/>
                <label htmlFor="emailAddress"> Email address<span className='redStar'>*</span></label>
                <br/>
                <input className='contactEmailInput' name="email" type="email" required 
                value={mail} onChange={(e)=>setMail(e.target.value)}/> 
                <br /> <br/>
                <label htmlFor="userPassword" >Your message<span className='redStar'>*</span></label>
                <br />
                <textarea  className='contactTextArea' name="message" required 
                    value={message} onChange={(e)=>setMessage(e.target.value)}>
                </textarea>
                <br />
                <br />
                <button className='contactSendButton'>Send </button>
            </form>
        </div>
    </section>
    )
}